import { ThemeConfig } from 'antd'

import { theme } from './theme'

export const antdTheme: ThemeConfig = {
  token: { colorPrimary: theme.primaryColor },
}
